// This script is used to redirect users based on their geolocation and language preference.;
const userLanguageChoice = {
  "fr_ca": "fr-CA",
  "en_ca_prod": "eachandevery.com",
  "en_ca_stage": "each-every-staging-site.myshopify.com",
  "userLanguageChoice": "userLanguageChoice",
  "GeolocationCoordinates": {
    "minLatitude": 44.7,
    "maxLatitude": 62.8,
    "minLongitude": -81.0,
    "maxLongitude": -69.3
  }
};
const consentMessage = "<p style='margin:20px;'>This site is not accessible in your region. <br/><br/>Ce site n'est pas accessible dans votre région.</p>";

document.addEventListener('DOMContentLoaded', function () {

  handleQuebecRedirection();

  const onFrenchConsent = () => {
    sessionStorage.setItem('userLanguageChoice', userLanguageChoice.fr_ca)
    document.body.innerHTML = consentMessage;
  }

  function handleQuebecRedirection() {
    const userChoice = sessionStorage.getItem(userLanguageChoice.userLanguageChoice)
    const currentPath = window.location.pathname
    const curretHost = window.location.hostname
    const redirectToLanguage = () => {
      document.body.innerHTML = consentMessage;
    }
    const handleGeoLocationSuccess = ({ coords: { latitude, longitude } }) => {
      const isWithinRegion = latitude >= userLanguageChoice.GeolocationCoordinates.minLatitude && latitude <= userLanguageChoice.GeolocationCoordinates.maxLatitude && longitude >= userLanguageChoice.GeolocationCoordinates.minLongitude && longitude <= userLanguageChoice.GeolocationCoordinates.maxLongitude
      const isEnglishPath = curretHost.includes(`${userLanguageChoice.en_ca_prod}`) || curretHost.includes(`${userLanguageChoice.en_ca_stage}`)
      if (!userChoice && isEnglishPath && isWithinRegion) {
        onFrenchConsent()
      }
    }

    const handleGeoLocationError = (error) => {
      console.error('Location Service Not Allowed')
    }

    if (!currentPath.includes(`/${userLanguageChoice.fr_ca}`)) {
      if (!userChoice) {
        navigator.geolocation?.getCurrentPosition(handleGeoLocationSuccess, handleGeoLocationError)
      } else if (userChoice === userLanguageChoice.fr_ca && (curretHost.includes(`/${userLanguageChoice.en_ca_prod}`) || curretHost.includes(`/${userLanguageChoice.en_ca_stage}`))) {
        redirectToLanguage()
      }
    }
  }
});
